// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const countBubblePositionStyles = (position: (string | null)[] | undefined) => {
    return css`
        ${cssProp("top", position?.[0])}
        ${cssProp("right", position?.[1])}
        ${cssProp("bottom", position?.[2])}
        ${cssProp("left", position?.[3])}
    `;
};

export const countBubbleStyles = (position?: (string | null)[], bgColor?: string) => {
    return css`
        ${countBubblePositionStyles(position)}
        position: absolute;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        font-size: ${pxToRem(9) /* Store Custom Code */};
        width: ${pxToRem(15) /* Store Custom Code */};
        height: ${pxToRem(15) /* Store Custom Code */};
        padding-top: ${pxToRem(3)};
        font-weight: ${x => x.theme.design.typography.weight.base /* Store Custom Code */};
        /* Store Removed - border */
        background-color: ${getColor("secondary") /* Store Custom Code */};
        color: ${getColor("header.accentContrast") /* Store Custom Code */};
        border-radius: 50%;
        line-height: ${pxToRem(16) /* Store Custom Code */};
    `;
};
